import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BookUploadContext } from './context';

const Span = styled.span`
	color: var(--shade-shade-60, #727780);
	font-family: Public Sans;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 24px; /* 171.429% */
	margin-left: 15px;
`
class InputChapter extends React.Component {
	static propTypes = {
		width: PropTypes.string.isRequired,
		placeholder: PropTypes.string.isRequired,
		spanText: PropTypes.string,
		titulo: PropTypes.string,
		field: PropTypes.string,
		chapterId: PropTypes.string,
	};

	static contextType = BookUploadContext;

	render() {
		const {
			width,
			placeholder,
			spanText,
			field,
			chapterId,
		} = this.props;
		const { data, handleDataChange } = this.context;

		return (
			<div>
				<Span>{spanText}</Span>
				<input
					style={{ width: `${width}` }}
					type="text"
					className="form-control"
					placeholder={placeholder}
					onChange={(((e) => handleDataChange(chapterId, field, e.target.value)))}
					value={data[chapterId][field]}
				/>
			</div>
		);
	}
}

export default InputChapter;
